import { render, staticRenderFns } from "./InfoBox.widget.vue?vue&type=template&id=a3ecfba6&scoped=true&"
import script from "./InfoBox.widget.vue?vue&type=script&lang=js&"
export * from "./InfoBox.widget.vue?vue&type=script&lang=js&"
import style0 from "./InfoBox.widget.vue?vue&type=style&index=0&id=a3ecfba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ecfba6",
  null
  
)

export default component.exports